<header class="ss-header">
  <button
    type="button"
    class="ss-header__mobile-menu-btn"
    aria-label="Abrir menu"
    (click)="openMobileMenu()">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M4 6h16M4 12h16M4 18h10"></path>
    </svg>
  </button>

  <a class="ss-header__logo" [routerLink]="appRoutes.events.list()" aria-label="SpotPass">
    <img src="assets/images/logo.svg" alt="SpotPass" />
  </a>

  <ss-global-search class="ss-header__search"></ss-global-search>

  <div class="ss-header__spacer"></div>

  <div class="ss-header__actions">
    <ss-theme-toggle></ss-theme-toggle>

    <ss-notifications [username]="username"></ss-notifications>

    <div id="userOptions" class="ss-header__user-wrapper">
      <button
        type="button"
        class="ss-header__user"
        [attr.aria-expanded]="!userOptions"
        aria-haspopup="menu"
        (click)="toggleUserOptions()">
        <span
          class="ss-header__user__photo"
          [ngStyle]="userImage ? {'background-image': 'url(' + userImage + ')'} : null">
          {{ userInitials }}
        </span>
        <span class="ss-header__user__info">
          <span class="ss-header__user__greeting">Bem-vindo(a),</span>
          <span class="ss-header__user__name">{{ username }}</span>
        </span>
        <lucide-icon
          name="chevron-down"
          [size]="14"
          class="ss-header__user__chevron"
          [class.is-open]="!userOptions"
          aria-hidden="true">
        </lucide-icon>
      </button>

      <div *ngIf="!userOptions" class="ss-header__user-menu ss-action-menu__panel" role="menu">
        <button
          type="button"
          role="menuitem"
          class="ss-header__user-menu__option ss-header__logout-btn ss-action-menu__item--danger"
          (click)="logout()">
          <span class="ss-action-menu__icon ss-action-menu__icon--danger">
            <lucide-icon name="log-out" [size]="15" aria-hidden="true"></lucide-icon>
          </span>
          <span>Sair</span>
        </button>
      </div>
    </div>
  </div>
</header>
